import React from 'react';
import { AlertCircle, AlertTriangle, X, RefreshCw } from 'lucide-react';
import { Button } from './button';
import { Alert, AlertDescription } from './alert';

interface ErrorDisplayProps {
  error: string | null;
  type?: 'error' | 'warning';
  title?: string;
  showIcon?: boolean;
  dismissible?: boolean;
  onDismiss?: () => void;
  onRetry?: () => void;
  className?: string;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
  error,
  type = 'error',
  title,
  showIcon = true,
  dismissible = false,
  onDismiss,
  onRetry,
  className = '',
}) => {
  if (!error) return null;

  const Icon = type === 'error' ? AlertCircle : AlertTriangle;
  const colorClasses = type === 'error' 
    ? 'border-red-200 bg-red-50 text-red-800' 
    : 'border-yellow-200 bg-yellow-50 text-yellow-800';

  return (
    <Alert className={`${colorClasses} ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-3">
          {showIcon && (
            <Icon className={`h-5 w-5 mt-0.5 ${type === 'error' ? 'text-red-500' : 'text-yellow-500'}`} />
          )}
          <div className="flex-1">
            {title && (
              <div className="font-medium mb-1">
                {title}
              </div>
            )}
            <AlertDescription className="text-sm">
              {error}
            </AlertDescription>
            {onRetry && (
              <Button
                variant="outline"
                size="sm"
                onClick={onRetry}
                className="mt-2"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                Try Again
              </Button>
            )}
          </div>
        </div>
        {dismissible && onDismiss && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onDismiss}
            className="h-auto p-1 hover:bg-transparent"
          >
            <X className="h-4 w-4" />
          </Button>
        )}
      </div>
    </Alert>
  );
};